module.exports = __webpack_public_path__ + "static/map_horizontal_ua-3b6460d9aa8c1ea9b034c6fd5673dd59.png";